
const BASE_URL = process.env.REACT_APP_BACKEND_URL;

export interface FlashInvadersProfile {
  pseudo: string;
  score: number;
  rank: number;
  siFound: number;
  cityFound: number;
  lastSyncDate: string;
}

export interface UserData {
  id: string;
  given_name: string;
  family_name: string;
  uuid: string | null;
  invadersCaptured: string[];
  flashProfile: FlashInvadersProfile | null;
}

export class GamerService {
  static async saveGamer(
      getAccessTokenSilently: () => Promise<string>,
      userId: string | undefined,
      givenName : string | undefined,
      familyName : string|  undefined
  ): Promise<UserData> {
    try {
      const accessToken = await getAccessTokenSilently();

      const response = await fetch(`${BASE_URL}/api/gamer/${encodeURIComponent(userId || '')}`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          id: userId,
          givenName: givenName,
          familyName: familyName,
        }),
      });

      if (!response.ok) {
        throw new Error(`Erreur HTTP : ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Erreur lors de la requête :", error);
      throw error;
    }
  };

  static async getMe(
      getAccessTokenSilently: () => Promise<string>
  ): Promise<UserData> {
    const accessToken = await getAccessTokenSilently();

    const response = await fetch(`${BASE_URL}/api/gamer/me`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Erreur HTTP : ${response.status}`);
    }

    return await response.json();
  }

  static async updateUuid(
      getAccessTokenSilently: () => Promise<string>,
      uuid: string
  ): Promise<UserData> {
    const accessToken = await getAccessTokenSilently();

    const response = await fetch(`${BASE_URL}/api/gamer/uuid`, {
      method: "PUT",
      headers: {
        'Content-Type': 'application/json',
        "Authorization": `Bearer ${accessToken}`,
      },
      body: JSON.stringify({ uuid }),
    });

    if (!response.ok) {
      throw new Error(`Erreur HTTP : ${response.status}`);
    }

    return await response.json();
  }

  static async canSync(
      getAccessTokenSilently: () => Promise<string>
  ): Promise<boolean> {
    const accessToken = await getAccessTokenSilently();

    const response = await fetch(`${BASE_URL}/api/gamer/can-sync`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Erreur HTTP : ${response.status}`);
    }

    const data = await response.json();
    return data.canSync;
  }

  static async syncFromClient(
      getAccessTokenSilently: () => Promise<string>,
      flashInvadersData: unknown
  ): Promise<{ success: boolean; message: string }> {
    const accessToken = await getAccessTokenSilently();

    const response = await fetch(`${BASE_URL}/api/gamer/sync`, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        "Authorization": `Bearer ${accessToken}`,
      },
      body: JSON.stringify(flashInvadersData),
    });

    const data = await response.json();

    if (!response.ok) {
      return { success: false, message: data.message || `Erreur HTTP : ${response.status}` };
    }

    return data;
  }
}